exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#statusPieSvgContainer {\n  width: 100%;\n  height: auto; }\n\n.arc-percentage-value {\n  font-size: xx-large;\n  font-weight: 600; }\n\n.arc-status-name {\n  font-weight: 100;\n  fill: #797e8d;\n  font-size: x-small; }\n\n.box-loader {\n  position: relative;\n  width: 80%;\n  top: 45px;\n  left: 0;\n  z-index: 5;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 30%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/dashboard/graph/pie-chart/pie-chart.component.scss
// module id = ../../../../../src/app/feature-modules/admin/dashboard/graph/pie-chart/pie-chart.component.scss
// module chunks = main